import {AfterViewInit, Component, ElementRef, inject, ViewChild, ChangeDetectionStrategy} from '@angular/core';
import {
  faCheck,
  faChevronDown,
  faChevronUp,
  faMessages,
  faPlus,
  faXmark
} from "@fortawesome/pro-solid-svg-icons";
import {ChatService} from "../service/chat.service";
import {Router} from "@angular/router";
import {StateConfigService} from "../../../services/state/state-config.service";
import {FaIconComponent} from '@fortawesome/angular-fontawesome';
import {BicButtonComponent} from '@buildinginformationcloud/bic-ui-components';

@Component({
  selector: 'app-chatBIC-top-nav',
    templateUrl: './chat-top-nav.component.html',
    styleUrls: ['./chat-top-nav.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [FaIconComponent, BicButtonComponent,]
})
export class ChatTopNavComponent implements AfterViewInit{
  chatService = inject(ChatService);

  /** Die Topbar gehört zur Chat-Seite, also zum klassischen Chat. */
  get session() {
    return this.chatService.session('classic');
  }
  private router = inject(Router);
  private stateConfigService = inject(StateConfigService);

    @ViewChild('renameTopic') renameTopicInput!: ElementRef<HTMLInputElement>;


  showRenameTopic: boolean = false;

  showLPHName(lph: string){
    return 'Leistungsphase '+lph.slice(-1)
  }
  // toggleAutoModuleSelector() {
  //   this.chatService.autoModuleSelector = !this.chatService.autoModuleSelector;
  // }
  showRenameInput() {
    this.showRenameTopic = true;
    setTimeout(() => {
      if (this.renameTopicInput) {
        const input = this.renameTopicInput.nativeElement;
        input.focus();
        input.select();
      }
    });
  }
  onOptionToggle(lph: string, event: any) {
    const checkbox = event.target as HTMLInputElement;
    const checked = checkbox.checked ?? !(document.getElementById(`checkbox-${lph}`) as HTMLInputElement)?.checked;
    const filter = this.chatService.filter.lph ??= [];

    if (checked) {
      filter.push(lph);
    } else {
      this.chatService.filter.lph = filter.filter(filter => filter !== lph);
    }

    if (checkbox.checked === undefined) {
      (document.getElementById(`checkbox-${lph}`) as HTMLInputElement).checked = checked;
    }
  }

  openNewChat() {
    this.chatService.resetChatState('classic');
    this.router.navigate(['projects', this.stateConfigService.getProjectId(), 'chat'])
  }

  isFilterDropdownShown() {
    const element = document.getElementById('filterMenu') as Element;
    return window.getComputedStyle(element).display != 'none';
  }

  ngAfterViewInit() {
  }

  protected readonly faChevronDown = faChevronDown;
  protected readonly faChevronUp = faChevronUp;
  protected readonly faMessages = faMessages;
  protected readonly faPlus = faPlus;
  protected readonly faXmark = faXmark;
  protected readonly faCheck = faCheck;
  topicInputIsFocused: boolean = false;
}
